import { InputHTMLAttributes, ReactNode, forwardRef } from 'react';
import type { LucideIcon } from 'lucide-react';
import { cn } from 'shared/utils/cn';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  /** Ícone à esquerda do campo (e-mail, senha, telefone…). */
  icon?: LucideIcon;
  /** Conteúdo à direita, dentro do campo (ex.: botão de mostrar senha). */
  endAdornment?: ReactNode;
  /** Texto de apoio abaixo do campo. */
  hint?: ReactNode;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { label, id, className, icon: Icon, endAdornment, hint, ...props },
  ref
) {
  const inputId = id ?? props.name;

  return (
    <label htmlFor={inputId} className="flex flex-col gap-1 text-sm text-ink">
      {label}
      <span className="relative flex items-center">
        {Icon && (
          <Icon className="pointer-events-none absolute left-3 h-4 w-4 text-ink-secondary" aria-hidden="true" />
        )}
        <input
          ref={ref}
          id={inputId}
          className={cn(
            'w-full rounded-lg border border-border bg-surface px-3 py-2 transition-shadow focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/20',
            Icon && 'pl-9',
            endAdornment ? 'pr-10' : undefined,
            className
          )}
          {...props}
        />
        {endAdornment && <span className="absolute right-1.5 flex items-center">{endAdornment}</span>}
      </span>
      {hint && <span className="text-xs text-ink-secondary">{hint}</span>}
    </label>
  );
});
